import React from 'react';

export default function Section({ title, children, className = '', style }) {
  const cls = ['section'];
  if (className) cls.push(className);
  return (
    <section className={cls.join(' ')} style={style}>
      {title ? <h3 style={{ marginTop: 0 }}>{title}</h3> : null}
      {children}
    </section>
  );
}
